import { FC, useRef, useState, useEffect, Dispatch, MutableRefObject, SetStateAction } from "react";
import { useParams } from "react-router-dom";
import {
  toAbsoluteUrl,
  valortotalDocumentosSeleccionados,
  baseUrl,
} from "../../helpers";

import {
  cargarDatosMaestros,
  realizarValidaciones,
  defaultState,
  consultarDocumentosPagoPersona,
} from "../../funcionesBase";

import {
  Idocumento,
  ServiciosVentas,
  TiposDocumentos,
  payLoadDatosMaestros,
  Iestado,
} from "../../helpers/dataExamples";

import { Formik, Form, FormikValues } from "formik";
import * as Yup from "yup";
import { StepperComponent } from "../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ResumenPago } from "./DetailPago";
import { IAlerta } from "./IAlerta";
import { DocumentoPago } from "./DocumentoPago";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { EpaycoCheckOut } from "../../modules/comfeModules";

import BlockUi from "react-block-ui";
import Loader from "react-loader-spinner";

import "react-block-ui/style.css";

interface ICreateAccount {}

const inits: ICreateAccount = {};

const createAppSchema = [Yup.object({})];

const PagosOnline: FC = () => {
  // add the user profile item
  const parametrosURL = useParams();
  const [loading, setLoading] = useState(false);
  const stepperRef = useRef<HTMLDivElement | null>(null);
  const stepper = useRef<StepperComponent | null>(null);
  const [currentSchema, setCurrentSchema] = useState(createAppSchema[0]);
  const [initValues] = useState<ICreateAccount>(inits);
  const MySwal = withReactContent(Swal);

  const tipo_docu = useRef<HTMLSelectElement>(null);
  const documento = useRef<HTMLInputElement>(null);
  const continuar_btn = useRef<HTMLButtonElement>(null);

  const [pantallaBloqueada, setPantallaBloqueada] = useState(false);
  const [errorMensaje, setErrorMensaje] = useState("");
  const [stepIndex, setStepIndex] = useState(1);

  let serviciosVentas: Array<ServiciosVentas> = [];
  const [serviciosVentasDisponibles, setServiciosVentasDisponibles] =
    useState(serviciosVentas);

  let tiposDocumentos: Array<TiposDocumentos> = [];
  const [tiposDocumentosDisponibles, setTiposDocumentosDisponibles] =
    useState(tiposDocumentos);

  let documentosPago: Array<Idocumento> = [];
  const [documentosPagoDisponibles, setDocumentosPagoDisponibles] =
    useState(documentosPago);

  const [showError, setShowError] = useState(false);
  const [estado, setEstado] = useState(defaultState);
  //const [hideLogo, sethideLogo] = useState<boolean>(false);

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(
      stepperRef.current as HTMLDivElement
    );
  };

  const prevStep = () => {
    setErrorMensaje("");
    setShowError(false);
    if (!stepper.current) {
      return;
    }
    stepper.current.goPrev();
    setStepIndex(stepper.current.currentStepIndex);
    setCurrentSchema(createAppSchema[stepper.current.currentStepIndex - 1]);

    if(stepper.current.currentStepIndex === 2){
      consultarDocumentosPagoPersona(
        estado,
        setPantallaBloqueada,
        documentosPago,
        setDocumentosPagoDisponibles,
        setEstado
      );
    }
  };

  const submitStep = (values: ICreateAccount, actions: FormikValues) => {
    if (!stepper.current || showError) {
      return;
    }

    setCurrentSchema(createAppSchema[stepper.current.currentStepIndex]);

    if (stepper.current.currentStepIndex !== stepper.current.totatStepsNumber) {
      stepper.current.goNext();
      setStepIndex(stepper.current.currentStepIndex);
    } else {
      setLoading(true);
      setTimeout(() => {
        MySwal.fire({
          icon: "success",
          title: <p>Pago realizado con exito</p>,
          footer: "Comfenalco 2021",
          didOpen: () => {
            // `MySwal` is a subclass of `Swal`
            //   with all the same instance & static methods
            //MySwal.clickConfirm()
          },
        }).then(() => {
          //eturn MySwal.fire(<p>Shorthand works too</p>)
          setLoading(false);
          stepper.current?.goto(1);
          actions.resetForm();
        });
      }, 2000);
    }
  };

  useEffect(() => {
    if (!stepperRef.current) {
      return;
    }

    loadStepper();
  }, [stepperRef]);

  /**************************************************/
  /**************************************************/
  /**************************************************/
  useEffect(() => {
    const payload: payLoadDatosMaestros = {
      tiposDocumentos: tiposDocumentos,
      serviciosVentas: serviciosVentas,
      parametrosURL: parametrosURL,
      estado: estado,
      stepper: stepper,
      setEstado: setEstado,
      setStepIndex: setStepIndex,
      setPantallaBloqueada: setPantallaBloqueada,
      setServiciosVentasDisponibles: setServiciosVentasDisponibles,
      setTiposDocumentosDisponibles: setTiposDocumentosDisponibles,
    };

    cargarDatosMaestros(payload);
  }, []);

  /*useEffect(() => {
    if(stepIndex === 2){
      consultarDocumentosPagoPersona(
        estado,
        setPantallaBloqueada,
        documentosPago,
        setDocumentosPagoDisponibles,
        setEstado
      );
    }
  }, [stepIndex])*/

  const _loader = (
    <Loader type="TailSpin" color="#164192" height={80} width={80} />
  );

  const queryParams = new URLSearchParams(window.location.search);
  var ocultarLogo:string | null  = queryParams.get("ocultarLogo");
  var cedula:string | null  = queryParams.get("cedula");
  var tdocumento:string | null  = queryParams.get("tdocumento");
  var showCard:string | null = queryParams.get("showCard");

  useEffect(() => {

    if(cedula !== null && tdocumento !== null){
      const newState = {...estado};
      newState.documento = cedula;
      newState.tipoDocumento = tdocumento;
      setEstado(newState);

      setTimeout(() => {
        continuar_btn.current?.click();
      }, 1)
    }
  }, []);

  return (
    <>
      <BlockUi blocking={pantallaBloqueada} loader={_loader}>
        <div id="contenedor-principal-pagos-online">
          <div className="Container-fluid pt-md-18 ">
            <div className="">
              <div className={"col-xs-12 col-sm-12 col-md-12 col-lg-12"}>
                <div
                  className={"card-custom bg-white shadow "+
                             "col-xs-12 offset-xs-0 "+
                             "col-sm-12 offset-sm-0 "+
                             "col-md-10 offset-md-1 "+
                             "col-xl-8 offset-xl-2 " +
                             "card rounded-4 "+ ((showCard === "false") && "card2")}
                  id="contenedor-pago-virtual2"
                >
                  <div className="card-header2">
                    <img
                      className={"img-fluid o-logo ps-8 " + ((ocultarLogo === "true") ? "d-none" : "")}
                      alt="Comfenalco"
                      src={toAbsoluteUrl(
                        "/media/logos/logoComfenalcoHorizontal.svg"
                      )}
                      width={"42%"}
                    ></img>
                    <h3 className="card-title fs-1 ms-5">Recaudos</h3>
                    <div className="card-toolbar"></div>
                  </div>
                  <div className="card-body">
                    <div
                      ref={stepperRef}
                      className="stepper stepper-pills"
                      id=""
                    >
                      <div
                        className="flex-row-fluid py-lg-5 px-lg-15 rounded-4"
                        id="stepper-contenedor"
                      >
                        <div className="stepper-nav d-flex justify-content-center">
                          <div
                            className="stepper-item current"
                            data-kt-stepper-element="nav"
                          >
                            <div className="stepper-line"></div>

                            <div className="stepper-icon">
                              <i className="stepper-check fas fa-check"></i>
                              <FontAwesomeIcon
                                className="stepper-check"
                                icon={"check"}
                              />
                              <span className="stepper-number">1</span>
                            </div>

                            <div className="stepper-label d-xs-none d-sm-none d-dm-block d-lg-block d-none">
                              <h3 className="stepper-title">Identificación</h3>

                              <div className="stepper-desc">
                                Documento de identidad
                              </div>
                            </div>
                          </div>

                          <div
                            className="stepper-item"
                            data-kt-stepper-element="nav"
                          >
                            <div className="stepper-line w-40px"></div>

                            <div className="stepper-icon w-40px h-40px">
                              <i className="stepper-check fas fa-check"></i>
                              <FontAwesomeIcon
                                className="stepper-check"
                                icon={"check"}
                              />
                              <span className="stepper-number">2</span>
                            </div>

                            <div className="stepper-label d-xs-none d-sm-none d-dm-block d-lg-block d-none">
                              <h3 className="stepper-title">
                                Referencia de pago
                              </h3>

                              <div className="stepper-desc">
                                Tipo de servicio y referencia
                              </div>
                            </div>
                          </div>

                          <div
                            className="stepper-item"
                            data-kt-stepper-element="nav"
                          >
                            <div className="stepper-line w-40px"></div>

                            <div className="stepper-icon w-40px h-40px">
                              <i className="stepper-check fas fa-check"></i>
                              <FontAwesomeIcon
                                className="stepper-check"
                                icon={"check"}
                              />
                              <span className="stepper-number">3</span>
                            </div>

                            <div className="stepper-label d-xs-none d-sm-none d-dm-block d-lg-block d-none">
                              <h3 className="stepper-title">
                                Detalle referencia
                              </h3>

                              <div className="stepper-desc">
                                Detalle del pago
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row pt-15">
                        <div className="col-md-4 d-xs-none d-sm-none d-dm-block d-lg-block d-none col-lg-3 col-xl-3">
                          <img
                            alt="pagando"
                            src={toAbsoluteUrl(
                              "/media/illustrations/pagando.png"
                            )}
                            className="img-fluid rounded-4"
                          ></img>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 rounded-4 border border-light">
                          <Formik
                            validationSchema={currentSchema}
                            initialValues={initValues}
                            onSubmit={submitStep}
                          >
                            <Form
                              className="form"
                              noValidate
                              id="kt_modal_create_app_form"
                            >
                              <div
                                className="current row"
                                data-kt-stepper-element="content"
                              >
                                <div className="">
                                  <div className="row mt-3">
                                    <div className="col">
                                      <label>
                                        <b>Tipo documento:</b>{" "}
                                      </label>
                                      <select
                                        className="form-select rounded-pill"
                                        id="select_tipo_doc"
                                        ref={tipo_docu}
                                        value={estado.tipoDocumento}
                                        onChange={(event) => {
                                          const newState = {
                                            ...estado,
                                            tipoDocumento: event.target.value,
                                          };
                                          setEstado(newState);
                                        }}
                                      >
                                        {tiposDocumentosDisponibles &&
                                          tiposDocumentosDisponibles.length >
                                            0 &&
                                          tiposDocumentosDisponibles.map(
                                            (doc, index) => {
                                              return (
                                                <option
                                                  key={index}
                                                  value={doc.codigo}
                                                >
                                                  {doc.abreviatura +
                                                    " - " +
                                                    doc.descripcion}
                                                </option>
                                              );
                                            }
                                          )}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="row mt-6">
                                    <div className="col">
                                      <label>
                                        <b>Número de documento:</b>{" "}
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-lg rounded-pill"
                                        id="input_documento"
                                        maxLength={14}
                                        placeholder="Numero de documento"
                                        ref={documento}
                                        value={estado.documento}
                                        onChange={(event) => {
                                          const newState = {
                                            ...estado,
                                            documento: event.target.value,
                                          };
                                          setEstado(newState);
                                        }}
                                      ></input>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div data-kt-stepper-element="content">
                                <div className="w-100">
                                  <div
                                    className="row rounded-2"
                                    id="nombre-detalle"
                                  >
                                    <span className="fw-bold">
                                      A nombre de:
                                      <span className="ml-4 fs-4 fw-bolder">
                                        {" " +
                                          estado.nombres +
                                          " " +
                                          estado.apellidos}
                                      </span>
                                    </span>
                                  </div>
                                  {stepIndex === 2 ? (
                                    <DocumentoPago
                                      documentos={documentosPagoDisponibles}
                                      estado={estado}
                                      setEstado={setEstado}
                                      serviciosVentas={
                                        serviciosVentasDisponibles
                                      }
                                    />
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>

                              <div data-kt-stepper-element="content">
                                {/*<div className="w-50 p-3">
                                  <h4>Datos personales</h4>
                                  <DetailPago3 estado={estado} />
                                  </div>*/}
                                <div className="w-100 bg-secondary bg-gradient rounded-3 p-3">
                                  <h4>Resumen pago</h4>
                                  <ResumenPago estado={estado} />
                                </div>
                              </div>

                              <div data-kt-stepper-element="content">
                                <div className="w-100"></div>
                              </div>

                              <div className={"d-flex flex-stack pt-10"}>
                                <div className={"me-2 "}>
                                  <button
                                    onClick={prevStep}
                                    type="button"
                                    className={
                                      "btn btn-comfe-light me-3 rounded-pill " +
                                      (parametrosURL.idpago ? "d-none" : "")
                                    }
                                    data-kt-stepper-action="previous"
                                    disabled={loading}
                                  >
                                    <FontAwesomeIcon icon={"arrow-left"} />
                                  </button>
                                </div>

                                <div className="mb-4">
                                  {stepIndex === 3 ? (
                                    <div id="targetEpayco">
                                      <EpaycoCheckOut
                                        keyAccount={estado.tokenEpayco}
                                        referencia={
                                          ""
                                          //estado.detalle_pago.referencia
                                        }
                                        email={estado.correo}
                                        amount={valortotalDocumentosSeleccionados(
                                          estado
                                        )}
                                        name={
                                          estado.referencias[
                                            estado.referenciaActiva
                                          ].descrip
                                        }
                                        descrip={
                                          estado.referencias[
                                            estado.referenciaActiva
                                          ].descrip
                                        }
                                        currency={"COP"}
                                        country={"CO"}
                                        test={true}
                                        external={true}
                                        url_response={
                                          "https://" + window.location.hostname
                                        }
                                        url_comfirm={
                                          baseUrl() +
                                          "Transacciones/guardarResultadoTransaccion"
                                        }
                                        estado={estado}
                                        setEstado={setEstado}
                                        stpb={setPantallaBloqueada}
                                      ></EpaycoCheckOut>
                                    </div>
                                  ) : (
                                    <button
                                      type="submit"
                                      className={
                                        "btn btn-comfe me-3 rounded-pill "
                                      }
                                      ref={continuar_btn}
                                      onClick={() => {
                                        realizarValidaciones(
                                          estado,
                                          showError,
                                          stepper,
                                          stepIndex,
                                          documentosPago,
                                          setErrorMensaje,
                                          setShowError,
                                          setPantallaBloqueada,
                                          setEstado,
                                          setStepIndex,
                                          setDocumentosPagoDisponibles
                                        );
                                      }}
                                      disabled={
                                        stepper.current?.currentStepIndex ===
                                          2 &&
                                        Object.keys(estado.referencias)
                                          .length === 0
                                      }
                                    >
                                      <span className="indicator-label">
                                        {stepper.current?.currentStepIndex !==
                                          stepper.current?.totatStepsNumber! -
                                            1 &&
                                          loading === false &&
                                          "Continuar "}
                                        {stepper.current?.currentStepIndex ===
                                          stepper.current?.totatStepsNumber! -
                                            1 &&
                                          loading === false &&
                                          "Continuar "}
                                        {loading && ""}
                                        {loading ? (
                                          <span
                                            className="indicator-progress"
                                            style={{ display: "block" }}
                                          >
                                            Por favor espere...
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                          </span>
                                        ) : (
                                          <FontAwesomeIcon
                                            icon={"arrow-right"}
                                          />
                                        )}
                                      </span>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </Form>
                          </Formik>
                        </div>
                      </div>
                    </div>
                    {showError && errorMensaje !== "" && (
                      <IAlerta
                        tipo={"bg-danger"}
                        mensaje={errorMensaje}
                      ></IAlerta>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlockUi>
    </>
  );
};

export { PagosOnline };
  function revisarDocumento(estado: Iestado, setEstado: Dispatch<SetStateAction<Iestado>>, setErrorMensaje: Dispatch<SetStateAction<string>>, setShowError: Dispatch<SetStateAction<boolean>>, stpb: any, stepper: MutableRefObject<StepperComponent | null>, setStepIndex: Dispatch<SetStateAction<number>>, documentosPago: Idocumento[], setDocumentosPagoDisponibles: Dispatch<SetStateAction<Idocumento[]>>) {
    throw new Error("Function not implemented.");
  }

